// extracted by mini-css-extract-plugin
module.exports = {"btn":"style__btn__o-bQH","infoBox":"style__infoBox__OSPPF","infoIcon":"style__infoIcon__yv51E","infoText":"style__infoText__pIKuu","center":"style__center__f6HUW"};